module.exports = __webpack_public_path__ + "img/Vietnam-4-hover.39126898.jpg";